import { render } from "./VendorOrdersIndex.vue?vue&type=template&id=e14ee2c4"
import script from "./VendorOrdersIndex.vue?vue&type=script&lang=js"
export * from "./VendorOrdersIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__